import PageComponent from '../base/PageComponent';

export default class NHILookup extends PageComponent {
  /**
   * Initialise
   */
  init() {
    this.bindInputChange();
  }

  /**
   * Listen to the onchange
   */
  bindInputChange() {
    this.getButton().on('click', (e) => this.lookupNHI(e)
    );
  }

  getInput() {
    return this.childElements('input');
  }

  getButton() {
    return this.childElements('.input-group-addon');
  }

  /**
   * find existing treatments for the patient is exists
   */
  lookupNHI(e) {
    e.preventDefault();
    var value = this.getInput().val();

    this.getInput().closest('.form-group').find('.parsley-errors-list').remove();

    if (value) {
      $.get('/treatments/findTreatmentsByNHI?nhi=' + value, (response) => {
        if (typeof response === 'object') {
          if (response.status === 1) {
            $(response.html).modal('show');
          }
          else {
            this.getInput().closest('.form-group').append('<ul style="position:absolute;width:100%;color:#337ab7;" class="parsley-errors-list filled"><li>Existing patient not found.</li></ul>');
          }
        }
      });
    }
  }
}
